import React from "react";
import classes from "./UserActionsItem.module.css";
import { ReactComponent as AvatarSVG } from "../icons/avatar.svg";

interface Props {
    descLink: string;
    link?: string;
    onClick?: () => void;
}

export default function UserActionsItem({ link, descLink, onClick }: Props) {
    return (
        <div className={classes.userActions__item}>
            <AvatarSVG />
            <a className={classes.userActions__link} href={onClick! ? "#" : link} onClick={onClick}>
                {descLink}
            </a>
        </div>
    );
}
